var WarningBar = function () {

	this.init = function () {
		$('.btn-close').on('click', function () {
			$(this).parents('[data-component="warning-bar"]').slideUp();
			$('#open-comunicado').fadeIn(700).show();
			setTimeout(function () {
				$('[data-component="warning-bar"]').hide();
			}, 1500);
		})
	}

	return this.init();
}

$('#open-comunicado').on('click', function () {
	$(this).fadeOut(900).hide();
	$(this).parents('[data-component="warning-bar"]').slideDown();
	$('[data-component="warning-bar"]').show();
});
